import Vue from 'vue'

export const namespaced = true

export const state = {
    subjects: [],
    subject: {},
    messages: [],
    total: 0,
    page: 1,
    limit: 10,
    subjectsLoading: false,
    subjectLoading: false,
    messagesLoading: false,
}

export const mutations = {
    SET_SUBJECTS_LOADING(state, loading) {
        state.subjectsLoading = loading
    },
    SET_SUBJECT_LOADING(state, loading) {
        state.subjectLoading = loading
    },
    SET_SUBJECTS_LIST(state, subjects) {
        state.subjects = subjects
    },
    SET_SUBJECT(state, subject) {
        state.subject = subject
    },
    SET_SUBJECTS_TOTAL(state, total) {
        state.total = total
    },
    SET_MESSAGES_LIST(state, messages) {
        state.messages = messages
    },
    SET_MESSAGES_LOADING(state, loading) {
        state.messagesLoading = loading
    }
}
export const actions = {
    getAllSubjects({commit, dispatch}, {page, limit}) {
        commit('SET_SUBJECTS_LOADING', true)
        //check values or take default
        page = page ? page : state.page
        limit = limit ? limit : state.limit

        return Vue.axios.get(`/subjects?page=${page}&limit=${limit}`)
            .then(response => {
                commit('SET_SUBJECTS_LIST', response.data)
                commit('SET_SUBJECTS_TOTAL', response.headers['x-total-count'])
                commit('SET_SUBJECTS_LOADING', false)
            })
            .catch(error => {
                commit('SET_SUBJECTS_LOADING', false)
                dispatch('displayError', {message: 'Erreur de chargement des sujets', error}, {root: true})
            })
    },
    getSubject({commit, dispatch}, id) {
        commit('SET_SUBJECT_LOADING', true)
        return Vue.axios.get(`/subjects/${id}`)
            .then(response => {
                commit('SET_SUBJECT', response.data)
                commit('SET_SUBJECT_LOADING', false)
            })
            .catch(error => {
                commit('SET_SUBJECT_LOADING', false)
                dispatch('displayError', {message: 'Erreur de chargement du sujet', error}, {root: true})
            })
    },
    addSubject({commit, dispatch}, subject) {
        commit('SET_SUBJECT_LOADING', true)
        return Vue.axios.post('/subjects', subject)
            .then(response => {
                commit('SET_SUBJECT', response.data.subject)
                commit('SET_SUBJECT_LOADING', false)
                commit('SET_MESSAGES_LIST', response.data.messages)
            })
            .catch(error => {
                commit('SET_SUBJECT_LOADING', false)
                dispatch('displayError', {message: 'Erreur de création du sujet', error}, {root: true})
            })
    },
    getMessagesOfSubject({commit, dispatch}, subject) {
        commit('SET_MESSAGES_LOADING', true)
        return Vue.axios.get(`/subjects/${subject}/messages`)
            .then(response => {
                commit('SET_MESSAGES_LIST', response.data)
                commit('SET_SUBJECT', response.data[0].subject)
                commit('SET_MESSAGES_LOADING', false)
            })
            .catch(error => {
                commit('SET_MESSAGES_LOADING', false)
                dispatch('displayError', {message: 'Erreur de chargement des messages', error}, {root: true})
            })
    },
    postMessageToSubject({commit, dispatch}, {subject_id, content}) {
        commit('SET_MESSAGES_LOADING', true)
        return Vue.axios.post(`/subjects/${subject_id}/messages`, {'content': content})
            .then(response => {
                commit('SET_MESSAGES_LIST', response.data.messages)
                commit('SET_SUBJECTS_LIST', response.data.subjects)
                commit('SET_MESSAGES_LOADING', false)
            })
            .catch(error => {
                commit('SET_MESSAGES_LOADING', false)
                dispatch('displayError', {message: 'Erreur de création du message', error}, {root: true})
            })
    }
}
